import React from "react";
import { SEO, MainLayout, PickupDetails } from "../../../components";
const DeliveryStepsPage = () => {
  return (
    <>
      <SEO title="delivery steps" />
      <MainLayout>
        <PickupDetails />
      </MainLayout>
    </>
  );
};

export default DeliveryStepsPage;
